// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB24Alh8FHtMKwlqRSOdpRZ6eEUBdrT-Wo",
  authDomain: "wedding-website-871ad.firebaseapp.com",
  projectId: "wedding-website-871ad",
  storageBucket: "wedding-website-871ad.firebasestorage.app",
  messagingSenderId: "412521919342",
  appId: "1:412521919342:web:7b04dbe15bc1de87f9c77f",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Authentication functions
export const signInAdmin = (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const signOutAdmin = () => {
  return signOut(auth);
};

export const onAuthStateChange = (callback: (user: any) => void) => {
  return onAuthStateChanged(auth, callback);
};
